import request from '@/utils/request'
import { BASE_API } from '@/api/baseUrl'

/**
 * 发货计划
 * 查询
 * @param {*} params
 */
export function apiMonthPlanFindList(data) {
  return request({
    // url: BASE_API() + '/monthplan/findMonthlyPlan',
    url: BASE_API() + '/wantGoodsDataQuery/findMonthlyPlan',
    method: 'post',
    data
  })
}
/**
 * 发货计划调整列表查询(申请入口)
 * 查询
 * @param {*} params
 */
export function apiMonthPlanChangeTableFindList(data) {
  return request({
    url: BASE_API() + '/monthplanadjuse/findMonthlyPlanAdjustList',
    // url: BASE_API() + '/wantGoodsDataQuery/findMonthlyPlanAdjustList',
    method: 'post',
    data
  })
}

/**
 * 发货计划
 * 根据id查询月度计划申请
 * @param {*} params
 */
export function apiMonthplanFindById({ id }) {
  return request({
    url: BASE_API() + '/monthplan/findById?id=' + id,
    method: 'post'
  })
}

/**
 * 发货计划调整
 * 根据id查询月度计划调整申请
 * @param {*} params
 */
export function apiMonthplanChangeFindById({ id }) {
  return request({
    url: BASE_API() + '/monthplanadjuse/findById?id=' + id,
    method: 'post'
  })
}

/**
 * 发货计划调整导入
 * 根据id查询月度计划调整申请
 * @param {*} params
 */
export function apiMonthplanChangeImportFindById({ id }) {
  return request({
    url: BASE_API() + '/monthplanadjuseimport/findById?id=' + id,
    method: 'post'
  })
}

/**
 * 发货计划调整
 * 查询
 * @param {*} params
 */
export function apiMonthPlanChangeFindList(data) {
  return request({
    url: BASE_API() + '/monthplanadjuse/findMonthlyPlanAdjust',
    method: 'post',
    data
  })
}

/**
 * 发货计划
 * 发货计划添加
 * @param {*} params
 */
export function monthplanAdd(data) {
  return request({
    url: BASE_API() + '/monthplan/add',
    method: 'post',
    data
  })
}

/**
 * 发货计划查询
 * 发货计划调整历史
 * @param {*} params
 */
export function apiFindAdjustmentHistory(data) {
  return request({
    url: BASE_API() + '/monthplanadjuseimport/findAdjustmentHistory',
    method: 'post',
    data
  })
}

/**
 * 发货计划单查询
 * @param {*} params
 */
export function apiDeliveryPlanOrder(data) {
  return request({
    url: BASE_API() + '/monthplan/findDeliverPlan',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/applyForGoods/monthly.js